import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ConsultationSessionService } from '@services/consultation-session-service';
import { LoadingModule } from '@components/loading';

@Component({
  selector: 'submit-default-answers',
  imports: [LoadingModule],
  templateUrl: './submit-default-answers.component.html',
})
export class SubmitDefaultAnswersComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly consultationSessionService = inject(ConsultationSessionService);

  ngOnInit(): void {
    this.processSubmitDefaultAnswers();
  }

  private async processSubmitDefaultAnswers(): Promise<void> {
    const consultationSession = this.consultationSessionService.getPendingConsultationSession();

    if (!consultationSession) {
      this.router.navigate(['/user'], { queryParams: { tab: 'home' } });
      return;
    }
    await this.consultationSessionService.submitDefaultAnswersAndNavigateToRegimenPage(consultationSession);
  }
}
